<template>
  <ion-page>
    <ion-progress-bar :value="0" v-show="$store.state.hide"></ion-progress-bar>
    <ion-content :scroll-events="true">
      <ion-refresher slot="fixed">
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <Header-Section />
      <div class="site-wrapper">
        <div class="main-wrapper">
          <div class="sidebar-nav">
            <nav>
              <ul>
                <li>
                  <router-link to="#"
                    ><span
                      ><i><svg-icon name="user" /></i></span
                    >Friend Requests</router-link
                  >
                </li>
              </ul>
            </nav>
          </div>
          <section id="profile-sufuria">
            <h2 style="margin-bottom: 10px; text-align: center">
              Friend Requests
            </h2>
            <div
              class="friend-shift-box-moja"
              style="display: flex; justify-content: center"
              v-if="friendRequests.length == 0"
            >
              <div
                style="display: flex; justify-content: center; margin-top: auto"
              >
                <i><svg-icon width="80" height="80" name="user" /></i
                ><span
                  ><i><svg-icon width="40" height="40" name="user" /></i
                ></span>
              </div>
              <br />
              <h5 style="text-align: center">
                When you have friend requests, you'll see them here.
              </h5>
            </div>
            <div class="friend-shift-box-moja">
              <div
                class="friend-box"
                v-for="(contact, index) in friendRequests"
                :key="index"
              >
                <div class="image-section">
                  <img
                    :src="`${this.$store.state.endpoints.appUrl}${contact.sender.image}`"
                    alt=""
                    style="border-radius: 50%"
                    v-if="contact.sender.image !== $store.state.avatar"
                  />
                  <avatar
                    :username="contact.sender.username"
                    style="width: 150px; height: 150px"
                    v-else
                  ></avatar>
                </div>
                <div>
                  <div class="friend-details">
                    <div class="left-deets">
                      <h3>{{ contact.sender.name }}</h3>
                      <!-- <p>{{ contact.sender.email }} friends</p> -->
                    </div>
                    <div class="tendo-btns">
                      <button
                        class="btn btn-accept"
                        @click="
                          acceptFriendRequest(
                            contact.id,
                            index,
                            contact.sender.username,
                            contact.sender.id
                          )
                        "
                      >
                        Accept
                      </button>
                      <button
                        class="btn btn-decline"
                        @click="declineFriendRequest(contact.id, index)"
                      >
                        Decline
                      </button>
                    </div>
                    <!-- <div
                      class="right-deets"
                      style="margin-top: 10px; cursor: pointer"
                      @click="
                        acceptFriendRequest(
                          contact.id,
                          index,
                          contact.sender.username,
                          contact.sender.id
                        )
                      "
                    >
                      <i
                        ><svg-icon
                          width="17"
                          height="17"
                          style="fill: green"
                          name="checkmark"
                      /></i>
                      Accept
                    </div>
                    <div
                      class="right-deets"
                      style="margin-top: 10px; cursor: pointer"
                      @click="declineFriendRequest(contact.id, index)"
                    >
                      <i
                        ><svg-icon
                          width="17"
                          height="17"
                          style="fill: red"
                          name="multiply"
                      /></i>
                      Decline
                    </div> -->
                  </div>
                  <div
                    class="people-suggestions"
                    v-if="contact.mutual"
                    style="margin-top: 10px"
                  >
                    <span
                      v-for="(cont, index) in contact.mutual.friends"
                      :key="index"
                    >
                      <img
                        :src="`${this.$store.state.endpoints.appUrl}${cont.user.image}`"
                        alt=""
                        v-if="cont.user.image !== $store.state.avatar" />
                      <avatar
                        :username="cont.user.username"
                        style="width: 1.4rem; height: 1.4rem"
                        v-else
                      ></avatar
                    ></span>
                    <p v-if="contact.mutual" style="margin-top: 10px">
                      &nbsp;{{ contact.mutual.mutual_count }} Mutual Friend<em
                        v-if="contact.mutual.mutual_count != 1"
                        >s</em
                      >
                    </p>

                    <!-- <span></span>
                    <span></span> -->
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonRefresher,
  IonRefresherContent,
  IonPage,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonBackButton,
  IonHeader,
} from "@ionic/vue";
import NavBar from "../navBar/index.vue";
import HeaderSection from "../navBar/header.vue";
import SvgIcon from "../../SvgIcon.vue";
import Avatar from "../../Avatar.vue";
export default {
  components: {
    IonContent,
    IonRefresher,
    IonRefresherContent,
    IonPage,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonBackButton,
    IonHeader,
    SvgIcon,
    HeaderSection,
    NavBar,
    Avatar,
  },
  data() {
    return {
      friendRequests: [],
    };
  },
  methods: {
    declineFriendRequest(pending_friend_request_id, index) {
      axios
        .get(
          `${this.$store.state.endpoints.declineFriendRequest}${pending_friend_request_id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          }
        )
        .then(() => {
          console.log(pending_friend_request_id);
        });
      this.friendRequests.splice(index, 1);
    },
    acceptFriendRequest(pending_friend_request_id, index, username, id) {
      axios
        .get(
          `${this.$store.state.endpoints.acceptFriendRequest}${pending_friend_request_id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          }
        )
        .then(() => {
          console.log(pending_friend_request_id);
          this.$store.dispatch("stories");
        });
      this.friendRequests.splice(index, 1);
      setTimeout(() => {
        axios
          .post(
            `${this.$store.state.endpoints.createMessagesUrl}${id}/`,
            {
              message: `Hello (${username})
              `,
              sender_id: this.$store.state.authuser.id,
            },
            { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
          )
          .then(() => {
            console.log();
          });
      }, 3000);
    },
  },
  computed: {},
  mounted() {
    axios
      .get(
        `${this.$store.state.endpoints.friendRequests}${this.$route.params.id}/`,
        {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
        }
      )
      .then((response) => {
        this.friendRequests = response.data;
        console.log();
      });
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600&family=Raleway:wght@600&family=Work+Sans:wght@300;400&display=swap");
@import "../../styles/font-poppins.css";
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
body {
  font-family: "Poppins", sans-serif;
  background: rgb(250, 250, 250);
  font-weight: 500;
}
.inner-row {
  width: 90%;
  margin: auto;
}
.profile-image {
  width: 40px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
  flex-shrink: 0;
}
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.site-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
header {
  width: 100%;
  background: white;
  position: fixed;
  z-index: 889;
  height: 70px;
  box-shadow: 0px 1px 2px rgb(231, 231, 231);
}
header .inner-row {
  height: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .logo-section {
  width: 50px;
  height: 50px;
}
.logo-section img {
  width: 135px;
}
.left-nav,
.right-nav {
  display: flex;
  align-items: center;
}

header .search-bar {
  background: whitesmoke;
  margin-left: 5%;
  width: 300px;
  padding: 0.5rem;
  border-radius: 1.2rem;
  -webkit-border-radius: 1.2rem;
  -moz-border-radius: 1.2rem;
  -ms-border-radius: 1.2rem;
  -o-border-radius: 1.2rem;
}
.search-control {
  border: none;
  background: transparent;
  outline: none;
  width: 80%;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  color: #333;
}
.quick-links {
  margin-right: 5%;
  display: flex;
}
.quick-links .notify,
.quick-links .message {
  font-size: 1.5rem;
  cursor: pointer;
  color: rgb(80, 80, 80);
  position: relative;
}
.badge {
  position: absolute;
  top: 0;
  right: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  background: rgb(235, 0, 0);
  box-shadow: 0px 0px 6px -1px rgb(250, 123, 123);
}
.badge span {
  font-size: 10px;
  font-weight: 600;
  color: white;
}
.profile-section {
  display: flex;
  align-items: center;
}
.profile-name {
  display: flex;
  align-items: center;
}
.profile-name h2 {
  font-size: 0.9rem;
  margin-left: 0.5rem;
  color: rgb(80, 80, 80);
}
.profile-name span {
  font-size: 1.2rem;
  cursor: pointer;
}

.navTrigger {
  cursor: pointer;
  width: 30px;
  height: 25px;
  margin: auto;
  position: absolute;
  right: 20px;
  top: 20px;
  opacity: 0;
  z-index: inherit;
}
.navTrigger i {
  background: #222;
  width: 100%;
  content: "";
  display: block;
  height: 4px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  -o-border-radius: 2px;
}
.navTrigger i:nth-child(1) {
  animation: outTp 0.8s backwards;
  -webkit-animation: outTp 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(2) {
  margin: 5px 0;
  animation: outMd 0.8s backwards;
  -webkit-animation: outMd 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(3) {
  animation: outBtm 0.8s backwards;
  -webkit-animation: outBtm 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger.active i:nth-child(1) {
  -webkit-animation: inTp 0.8s forwards;
  animation: inTp 0.8s forwards;
}

.navTrigger.active i:nth-child(2) {
  -webkit-animation: inMd 0.8s forwards;
  animation: inMd 0.8s forwards;
}

.navTrigger.active i:nth-child(3) {
  -webkit-animation: inBtm 0.8s forwards;
  animation: inBtm 0.8s forwards;
}
/*Keyframes*/
@keyframes inMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes outMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes inTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes outTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes inBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@keyframes outBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

.main-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 20px;
  top: 70px;
  background: rgb(250, 250, 250);
}
.sidebar-nav {
  width: 250px;
  background: #fff;
  position: fixed;
  top: 90px;
  left: 50px;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  box-shadow: 0px 0px 6px -1px rgb(216, 216, 216);
}
.sidebar-nav.hide {
  margin-left: -250px;
  transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
}
.sidebar-nav nav ul li {
  display: block;
  padding-left: 15px;
  line-height: 45px;
  margin-bottom: 10px;
}
.sidebar-nav nav ul li:hover {
  background: rgb(247, 250, 252);
  transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -ms-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
}

.sidebar-nav nav ul li span {
  font-size: 20px;
}
.sidebar-nav nav ul li a {
  color: #111;
  display: flex;
  align-items: center;
  font-size: 15px;
}
.sidebar-nav nav ul li:hover a {
  color: rgba(0, 129, 204, 0.822);
}

.mobile-sidebar {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 40%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: -100%;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
  display: none;
}
.mobile-sidebar.active {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: 0;
}
.mobile-nav-link {
  display: block;
  line-height: 40px;
  color: #222;
  font-size: 0.9rem;
}

.mobile-profile {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 1rem 0;
}
.mobile-profile .profile-text p {
  font-size: 0.7rem;
  color: #444;
}
.mobile-sidebar .logout {
  padding: 0.5rem 0;
  margin-top: 1rem;
  border-top: 1px solid gainsboro;
}
.mobile-sidebar .logout a {
  font-size: 0.9rem;
  color: #222;
}

#profile-sufuria {
  margin-left: 320px;
  border-radius: 20px;
  position: relative;
  width: 73%;
  top: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
  padding-bottom: 50px;
}
.cover-photo-section {
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0px 0px 4px 1px rgb(240, 240, 240);
}
.cover-photo-section .cover-image {
  width: 100%;
  height: 250px;
  position: relative;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  overflow: hidden;
}
.cover-image .action-controls {
  position: absolute;
  bottom: 50px;
  right: 8px;
  display: flex;
  gap: 20px;
}
.action-controls span {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(238, 238, 238);
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  cursor: pointer;
}
.person-image {
  position: relative;
  display: flex;
  justify-content: center;
}
.person-image-itselfu {
  /* width: 160px;
      height: 160px; */
  width: 240px;
  height: 240px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px rgb(131, 131, 131);
  margin-top: -110px;
}
.social-intro-section {
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
}

.social-media-links {
  display: flex;
  gap: 20px;
}

.social-media-links a,
.social-media-links a img {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  overflow: hidden;
}
.user-profile-name h2 {
  font-size: 25px;
  font-weight: 500;
}

.user-garnering {
  display: flex;
  gap: 20px;
}
.garner-moja {
  text-align: center;
}
.garner-moja h4 {
  font-size: 17px;
}

.shift-controls {
  margin: 20px 0;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0px 0px 4px 1px rgb(240, 240, 240);
}
.shift-controls ul {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: #fff;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.shift-controls ul li {
  text-align: center;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #333;
  font-size: 15px;
  cursor: pointer;
}
.shift-controls ul li.active {
  background: rgb(0, 153, 255);
  color: white;
}

.shift-container-moja {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.left-side .number-of-items-container {
  padding: 20px 10px;
  display: flex;
  gap: 5px;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 0px 4px 1px rgb(240, 240, 240);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  margin-bottom: 20px;
}
.number-of-items-container span {
  width: 24px;
  height: 24px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  background: rgb(0, 162, 255);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.event-preview-container,
.photos-preview-container,
.friends-preview-container {
  background: #fff;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0px 0px 4px 1px rgb(240, 240, 240);
}
.left-side .title {
  padding: 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid gainsboro;
}
.title h2 {
  font-size: 20px;
  font-weight: 500;
}
.title a {
  font-size: 15px;
  color: rgb(0, 153, 255);
}
.events-column {
  padding: 0px 10px 10px;
  margin: 20px 0;
}
.events-column .event-moja {
  margin-bottom: 30px;
}
.event-moja .image-box {
  height: 200px;
  position: relative;
}
.event-moja .image-box img {
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.event-moja .image-box span {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  bottom: -20px;
  background: rgb(0, 153, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
}
.event-moja .event-name {
  margin-top: 30px;
  text-align: center;
}
.event-name h4 {
  font-size: 18px;
  font-weight: 500;
}
.event-name p {
  font-size: 14px;
  color: #444;
  margin-top: 5px;
}

.photos-preview-container .photos-grid {
  grid-template-columns: repeat(3, 1fr);
  display: grid;
  gap: 10px;
  padding: 20px 10px;
}
.photos-grid .photo-moja {
  height: 90px;
}
.friends-preview-container {
  margin-top: 20px;
}
.friends-grid {
  padding: 20px 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.friend-moja-image img {
  height: 90px;
}
.friend-moja-image {
  text-align: center;
}
.friend-moja-image p {
  font-size: 14px;
}

.right-side {
  grid-column: 2/5;
}
.right-side .title {
  padding: 18px 10px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 0px 4px 1px rgb(240, 240, 240);
  margin-bottom: 20px;
}

/* -------Posts------*/
.posts-container .post {
  background: #fff;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  padding: 1rem;
  margin: 1rem 0;
  font-size: 0.85rem;
  line-height: 1.3rem;
}

.post .post-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.post-head .user {
  display: flex;
  gap: 1rem;
}
.post-head .namlo {
  color: #333;
}
.post-head .namlo h3 {
  font-size: 18px;
}
.post-head span {
  cursor: pointer;
}
.post .post-photo {
  overflow: hidden;
  margin: 0.7rem 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
.post .sentence-post,
.post .video-post {
  margin: 1rem 0;
}

.post .action-btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.3rem;
  margin: 0.5rem;
  line-height: 1;
}
.action-btns span {
  cursor: pointer;
  position: relative;
}
.action-btns .interaction-btns {
  display: flex;
  align-items: center;
  padding-left: 35px;
  gap: 12px;
}
.like-btn {
  width: 30px;
  height: 30px;
  position: absolute;
  display: inline-block;
  left: 0px;
  top: 0px;
}
.like-btn svg {
  width: 40px;
  margin-left: -8px;
  margin-top: -5px;
}
.like-btn svg #heart {
  transform-origin: center;
  animation: animationHeartOut 0.3s linear forwards;
  -webkit-animation: animationHeartOut 0.3s linear forwards;
}
.like-btn svg #main-circ {
  transform-origin: 29.5px 29.5px;
}

.like-btn.animate svg #heart {
  transform: scale(0.2);
  -webkit-transform: scale(0.2);
  -moz-transform: scale(0.2);
  -ms-transform: scale(0.2);
  -o-transform: scale(0.2);
  fill: #e2264d;
  animation: animateHeart 0.3s linear forwards 0.2s;
  -webkit-animation: animateHeart 0.3s linear forwards 0.2s;
}
.like-btn.animate svg #main-circ {
  transition: all 2s;
  -webkit-transition: all 2s;
  -moz-transition: all 2s;
  -ms-transition: all 2s;
  -o-transition: all 2s;
  animation: animateCircle 0.3s linear forwards;
  -webkit-animation: animateCircle 0.3s linear forwards;
  opacity: 1;
}
.like-btn.animate svg #grp1 {
  opacity: 1;
  transition: 0.1s all 0.3s;
  -webkit-transition: 0.1s all 0.3s;
  -moz-transition: 0.1s all 0.3s;
  -ms-transition: 0.1s all 0.3s;
  -o-transition: 0.1s all 0.3s;
}
.like-btn.animate svg #grp1 #oval1 {
  transform: scale(0) translate(0, -30px);
  -webkit-transform: scale(0) translate(0, -30px);
  -moz-transform: scale(0) translate(0, -30px);
  -ms-transform: scale(0) translate(0, -30px);
  -o-transform: scale(0) translate(0, -30px);
  transform-origin: 0 0 0;
  transition: 0.5s transform 0.4s;
  -webkit-transition: 0.5s transform 0.4s;
  -moz-transition: 0.5s transform 0.4s;
  -ms-transition: 0.5s transform 0.4s;
  -o-transition: 0.5s transform 0.4s;
}
.like-btn.animate svg #grp1 #oval2 {
  transform: scale(0) translate(10px, -50px);
  -webkit-transform: scale(0) translate(10px, -50px);
  -moz-transform: scale(0) translate(10px, -50px);
  -ms-transform: scale(0) translate(10px, -50px);
  -o-transform: scale(0) translate(10px, -50px);
  transform-origin: 0 0 0;
  transition: 1.5s transform 0.4s;
  -webkit-transition: 1.5s transform 0.4s;
  -moz-transition: 1.5s transform 0.4s;
  -ms-transition: 1.5s transform 0.4s;
  -o-transition: 1.5s transform 0.4s;
}
.like-btn.animate svg #grp2 {
  opacity: 1;
  transition: 0.1s all 0.4s;
  -webkit-transition: 0.1s all 0.4s;
  -moz-transition: 0.1s all 0.4s;
  -ms-transition: 0.1s all 0.4s;
  -o-transition: 0.1s all 0.4s;
}

.like-btn.animate svg #grp2 #oval1 {
  transform: scale(0) translate(30px, -15px);
  transform-origin: 0 0 0;
  transition: 0.5s transform 0.3s;
}

.like-btn.animate svg #grp2 #oval2 {
  transform: scale(0) translate(60px, -15px);
  transform-origin: 0 0 0;
  transition: 1.5s transform 0.3s;
}

.like-btn.animate svg #grp3 {
  opacity: 1;
  transition: 0.1s all 0.3s;
}

.like-btn.animate svg #grp3 #oval1 {
  transform: scale(0) translate(30px, 0px);
  transform-origin: 0 0 0;
  transition: 0.5s transform 0.3s;
}

.like-btn.animate svg #grp3 #oval2 {
  transform: scale(0) translate(60px, 10px);
  transform-origin: 0 0 0;
  transition: 1.5s transform 0.3s;
}

.like-btn.animate svg #grp4 {
  opacity: 1;
  transition: 0.1s all 0.3s;
}

.like-btn.animate svg #grp4 #oval1 {
  transform: scale(0) translate(30px, 15px);
  transform-origin: 0 0 0;
  transition: 0.5s transform 0.3s;
}

.like-btn.animate svg #grp4 #oval2 {
  transform: scale(0) translate(40px, 50px);
  transform-origin: 0 0 0;
  transition: 1.5s transform 0.3s;
}

.like-btn.animate svg #grp5 {
  opacity: 1;
  transition: 0.1s all 0.3s;
}

.like-btn.animate svg #grp5 #oval1 {
  transform: scale(0) translate(-10px, 20px);
  transform-origin: 0 0 0;
  transition: 0.5s transform 0.3s;
}

.like-btn.animate svg #grp5 #oval2 {
  transform: scale(0) translate(-60px, 30px);
  transform-origin: 0 0 0;
  transition: 1.5s transform 0.3s;
}

.like-btn.animate svg #grp6 {
  opacity: 1;
  transition: 0.1s all 0.3s;
}

.like-btn.animate svg #grp6 #oval1 {
  transform: scale(0) translate(-30px, 0px);
  transform-origin: 0 0 0;
  transition: 0.5s transform 0.3s;
}

.like-btn.animate svg #grp6 #oval2 {
  transform: scale(0) translate(-60px, -5px);
  transform-origin: 0 0 0;
  transition: 1.5s transform 0.3s;
}

.like-btn.animate svg #grp7 {
  opacity: 1;
  transition: 0.1s all 0.3s;
}

.like-btn.animate svg #grp7 #oval1 {
  transform: scale(0) translate(-30px, -15px);
  transform-origin: 0 0 0;
  transition: 0.5s transform 0.3s;
}

.like-btn.animate svg #grp7 #oval2 {
  transform: scale(0) translate(-55px, -30px);
  transform-origin: 0 0 0;
  transition: 1.5s transform 0.3s;
}

.like-btn.animate svg #grp2 {
  opacity: 1;
  transition: 0.1s opacity 0.3s;
}

.like-btn.animate svg #grp3 {
  opacity: 1;
  transition: 0.1s opacity 0.3s;
}

.like-btn.animate svg #grp4 {
  opacity: 1;
  transition: 0.1s opacity 0.3s;
}

.like-btn.animate svg #grp5 {
  opacity: 1;
  transition: 0.1s opacity 0.3s;
}

.like-btn.animate svg #grp6 {
  opacity: 1;
  transition: 0.1s opacity 0.3s;
}

.like-btn.animate svg #grp7 {
  opacity: 1;
  transition: 0.1s opacity 0.3s;
}

@keyframes animateCircle {
  40% {
    transform: scale(10);
    opacity: 1;
    fill: #dd4688;
  }
  55% {
    transform: scale(11);
    opacity: 1;
    fill: #d46abf;
  }
  65% {
    transform: scale(12);
    opacity: 1;
    fill: #cc8ef5;
  }
  75% {
    transform: scale(13);
    opacity: 1;
    fill: transparent;
    stroke: #cc8ef5;
    stroke-width: 0.5;
  }
  85% {
    transform: scale(17);
    opacity: 1;
    fill: transparent;
    stroke: #cc8ef5;
    stroke-width: 0.2;
  }
  95% {
    transform: scale(18);
    opacity: 1;
    fill: transparent;
    stroke: #cc8ef5;
    stroke-width: 0.1;
  }
  100% {
    transform: scale(19);
    opacity: 1;
    fill: transparent;
    stroke: #cc8ef5;
    stroke-width: 0;
  }
}

@keyframes animateHeart {
  0% {
    transform: scale(0.2);
  }
  40% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes animateHeartOut {
  0% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}

.post .people-likings {
  display: flex;
}
.people-likings span {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  border: 2px solid gainsboro;
  margin-left: -0.6rem;
}
.people-likings span:first-child {
  margin: 0;
}
.people-likings p {
  margin-left: 0.5rem;
}

.caption {
  margin: 0.3rem 0;
  color: #333;
  text-align: justify;
}
.comments {
  color: gray;
  cursor: pointer;
}

.comments-list {
  margin-top: 1rem;
}
.comments-list .comment {
  display: grid;
  grid-template-columns: 40px 90%;
}
.comment .profile-image {
  width: 35px;
  height: 35px;
}
.comment .comment-body {
  background: rgb(241, 241, 241);
  padding: 0.5rem;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
.create-comment {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
  display: none;
}
.create-comment .profile-image {
  width: 40px;
  height: 40px;
}
.input-comment {
  width: 85%;
}
.input-comment .comment-control {
  height: 40px;
  width: 100%;
  padding: 0.5rem;
  font-family: "Poppins";
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  background-color: #ddd;
  border: none;
  outline: none;
  resize: none;
  color: #333;
}
.comment-control::placeholder {
  font-size: 0.8rem;
}
.create-comment span {
  font-size: 30px;
  color: rgb(0, 110, 255);
  cursor: pointer;
}

/* Styling for second shift container */
.shift-container-moja.second {
  background: #fff;
  padding: 20px 10px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  gap: 0;
}

.left-side .details-controls ul {
  width: 80%;
}
.left-side .details-controls ul li {
  line-height: 30px;
  display: inline-block;
  margin-bottom: 10px;
  padding: 5px 10px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  cursor: pointer;
  color: rgb(0, 153, 255);
  font-size: 15px;
}
.left-side .details-controls ul li.active {
  background: rgb(233, 251, 255);
}
.title-2 {
  padding: 0px 0 18px;
  border-bottom: 1px solid gainsboro;
}
.title-2 h3 {
  font-size: 24px;
  font-weight: 500;
}
.contact-details {
  margin: 20px 0;
}
.contact-details .contact-detail-moja {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.contact-detail-moja h3 {
  font-size: 15px;
  line-height: 25px;
  font-weight: 500;
}

/* Third shift container */
.shift-container-moja.third,
.shift-container-moja.fourth {
  grid-template-columns: repeat(1, 1fr);
  background-color: #fff;
  box-shadow: 0px 0px 4px 1px rgb(240, 240, 240);
  padding: 20px 10px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.title-3 {
  margin-bottom: 10px;
}
/* .friend-shift-controls ul {
      display: flex;
      gap: 20px;
    }
    .friend-shift-controls ul li {
      color: rgb(0, 162, 255);
      font-size: 16px;
      cursor: pointer;
    } */
.friend-shift-controls ul,
.friend-shift-controls-2 ul {
  display: flex;
  gap: 20px;
}
.friend-shift-controls ul li,
.friend-shift-controls-2 ul li {
  color: rgb(0, 162, 255);
  font-size: 16px;
  cursor: pointer;
}

.friend-shift-boxes {
  margin: 20px 0;
}
.friend-shift-box-moja {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  width: 100%;
}
.friend-box {
  display: flex;
  gap: 10px;
  align-items: center;
  border: 1px solid rgb(223, 223, 223);
}
.friend-box .image-section {
  height: 150px;
  width: 150px;
  flex-shrink: 0;
}
.friend-details {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.friend-details h3 {
  font-size: 17px;
}
.friend-details p {
  font-size: 14px;
  margin-top: 5px;
}
.friend-details .right-deets {
  padding: 5px 10px;
  margin-right: 15px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  background: gainsboro;
  font-size: 14px;
}

/* .photos-zangu-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px;
      margin: 20px 0;
    } */

.photos-zangu-container .photo-tab-moja {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin: 20px 0;
}

.photo-yangu img {
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

/* About details styling */
.about-details-moja.sp .title-2 {
  border: none;
  padding-bottom: 10px;
}
.title-2 p {
  margin: 10px 0;
  color: #333;
  cursor: pointer;
  font-size: 15px;
}
.k-member-moja {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
}
.k-profile-image,
.k-profile-image img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}
.left-deets {
  display: flex;
  align-items: center;
  gap: 10px;
}
.left-deets h5 {
  color: #333;
}
.left-deets p {
  color: #333;
  font-size: 14px;
}
.right-deets {
  margin-right: 20px;
}
.about-description {
  margin-bottom: 10px;
}
.about-description p {
  font-size: 16px;
  color: #333;
  line-height: 25px;
}

@media (max-width: 1100px) {
  .mobile-sidebar {
    display: block;
  }
  .sidebar-nav {
    margin-left: -300px;
  }
  .sidebar-nav.show {
    margin-left: 0;
    z-index: 99;
  }
  #profile-sufuria {
    width: 90%;
    margin: auto;
    overflow: hidden;
  }
  .navTrigger {
    opacity: 1;
  }
  header .search-bar,
  .right-nav {
    display: none;
  }
  .form-row.split {
    gap: 20px;
  }
}

@media (max-width: 900px) {
  .social-intro-section {
    flex-direction: column;
    gap: 10px;
  }
  .user-profile-name h2 {
    text-align: center;
  }
  .social-media-links,
  .user-garnering {
    justify-content: center;
  }
  .photos-zangu-container {
    grid-template-columns: repeat(3, 1fr);
  }
  .friend-shift-box-moja {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (max-width: 768px) {
  .shift-container-moja {
    grid-template-columns: repeat(1, 1fr);
  }
  .right-side {
    grid-column: 1/2;
    order: 1;
  }
  .left-side {
    order: 2;
  }
  .shift-container-moja.second .right-side {
    order: 2;
  }
  .left-side .details-controls ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
  }
  .contact-details .contact-detail-moja {
    grid-template-columns: repeat(2, 1fr);
  }
  .photos-zangu-container {
    grid-template-columns: repeat(2, 1fr);
  }
  .friend-shift-controls ul {
    flex-wrap: wrap;
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .shift-controls ul li {
    height: 40px;
  }
  .social-media-links {
    gap: 10px;
  }
  .person-image-itselfu {
    /* width: 120px;
        height: 120px; */
    width: 240px;
    height: 240px;
    margin-top: -110px;
  }

  .person-image span {
    right: 20px;
  }

  .cover-image .action-controls {
    gap: 10px;
    flex-direction: column;
  }
  .user-profile-name h2 {
    font-size: 20px;
  }
  .title-2 {
    padding-bottom: 10px;
  }
  .title-2 h3 {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }
  .friend-details {
    flex-direction: column;
  }
}
@media (max-width: 320px) {
  .friend-details h3 {
    font-size: 14px;
  }
  .friend-details .right-deets {
    background-color: transparent;
    padding: 0;
    color: rgb(0, 153, 255);
    margin-left: -20px;
  }
  .right-deets i {
    display: none;
  }
}

.popup {
  position: absolute;
  color: #fff;
  background-color: transparent;
  padding: 10px;
  padding-bottom: 58px;
  border-radius: 5px;
  transform-origin: center, center;
  cursor: pointer;
  z-index: 889;
}
.popup:after {
  content: "";
  border-bottom: 5px solid gainsboro;
  border-right: 5px solid gainsboro;
  border-top: 5px solid transparent;
  border-left: 5px solid transparent;
  position: absolute;
  top: calc(100% - 64px);
  transform: rotate(45deg);
  left: calc(50% - 164px);
  z-index: 889;
}

.people-suggestions {
  display: flex;
}

.people-suggestions span {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  border: 2px solid gainsboro;
  margin-left: -0.6rem;
}
.people-suggestions span:first-child {
  margin: 0;
}

.tendo-btns {
  display: flex;
  gap: 1rem;
}
.tendo-btns .btn {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  cursor: pointer;
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -moz-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  font-size: 0.8rem;
  border: none;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  color: #fff;
}
.tendo-btns .btn-accept {
  background: rgb(0, 110, 255);
}
.tendo-btns .btn-decline {
  background: rgba(255, 0, 0, 0.616);
}
</style>
